/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Feb 21 2024
 **/

import { useMemo } from "react";
import { debounce } from "lodash-es";
import { Configure } from "@/frameworks/libraries/utilities";

export default function useFoldingBHandler() {
	const handleSaveHeight = (id: string, height: UnitString) => {
		console.debug("handleSaveHeight", id, height, Configure.foldingBPosition[id]);
		Configure.foldingBPosition = {
			...Configure.foldingBPosition,
			[id]: {
				...Configure.foldingBPosition[id],
				height: height
			}
		};
	};
	const handleDebouncedHeight = useMemo(
		() => debounce((id: string, height: string) => handleSaveHeight(id, height as UnitString), 200),
		[]
	);

	const getFoldingBHeight = (id: string) => {
		return Configure.foldingBPosition[id]?.height;
	};

	return {
		handleDebouncedHeight,
		getFoldingBHeight
	};
}
